import axios from "axios";
import { API_URL } from "../utils/Constant";

/**
 * Per-row delayed report / ETA activity history. Response envelope matches {@link getDelayedReports}
 *
 * @param {number} test in sample pk
 * @param {AbortSignal} [signal] Abort Signal
 * @returns {Promise<{ success: boolean, results?: object[], message?: string, canceled?: boolean }>}
 */
export const getDelayedReportLogs = async (tests_in_sample_PK, signal) => {
  try {
    const params = { tests_in_sample_PK };
    const response = await axios.get(`${API_URL}/report_delay_logs/`, { params, signal });
    return { success: true, canceled: false, ...response.data };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

/**
 * @param {object} [params]  Query string params (e.g. { date: "YYYY-MM-DD" } — confirm with backend)
 * @param {AbortSignal} [signal]
 */
export const getDelayedReports = async (params, signal) => {
  try {
    const response = await axios.get(`${API_URL}/report_delay/`, { params, signal });
    return { success: true, ...response.data };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

export const updatedReportDelay = async (payload, signal) => {
  try {
    const response = await axios.post(`${API_URL}/report_delay/`, payload, { signal });
    return { success: true, ...response.data };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};

/**
 * Fetch delay reasons for both Standard and Lab Ops categories.
 * @param {AbortSignal} [signal]
 */
export const getReasons = async (signal) => {
  try {
    const params = new URLSearchParams();
    params.append("reasons_category", "standard");
    params.append("reasons_category", "labops");
    const response = await axios.get(`${API_URL}/reasons/`, { params, signal });
    return { success: true, ...response.data };
  } catch (e) {
    return {
      success: false,
      message: e.response?.data?.message || "Something went wrong.",
      canceled: e.code === "ERR_CANCELED",
    };
  }
};
